import { Badge } from "@/design/components";
import { platformLabel, type AgentSummary } from "@/api/agents";
import styles from "./AgentList.module.css";

function formatWhen(iso: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

/**
 * Presentational list of connected agents — shared by the customer Channels screen
 * (grouped per channel) and the operator org-detail screen (per org). Shows only
 * the fields the relay captures: platform (Claude / Codex), client version, working
 * directory, and connected-since. Nullable fields are simply omitted.
 */
export function AgentList({ agents }: { agents: AgentSummary[] }) {
  return (
    <ul className={styles.list}>
      {agents.map((a) => {
        const when = formatWhen(a.registeredAt);
        return (
          <li key={`${a.sessionId}:${a.peerId}`} className={styles.item}>
            <div className={styles.head}>
              <Badge tone={a.platform === "cc" ? "accent" : "neutral"}>{platformLabel(a.platform)}</Badge>
              <span className={styles.peer}>{a.label || a.peerId}</span>
              {a.clientVersion && <span className={styles.version}>v{a.clientVersion}</span>}
            </div>
            {(a.cwd || when) && (
              <dl className={styles.meta}>
                {a.cwd && (
                  <div className={styles.metaRow}>
                    <dt className={styles.metaLabel}>Directory</dt>
                    <dd className={styles.mono}>{a.cwd}</dd>
                  </div>
                )}
                {when && (
                  <div className={styles.metaRow}>
                    <dt className={styles.metaLabel}>Connected</dt>
                    <dd>{when}</dd>
                  </div>
                )}
              </dl>
            )}
          </li>
        );
      })}
    </ul>
  );
}
